import { render, staticRenderFns } from "./TaskStatusButton.vue?vue&type=template&id=ce276828&"
import script from "./TaskStatusButton.vue?vue&type=script&lang=js&"
export * from "./TaskStatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports